import z from 'zod';
export const crossword_data_entry_direction_schema = z
    .string()
    .trim()
    .regex(/^(across|down)$/);
export const crossword_data_dimensions_schema = z.object({
    width: z.number().min(5).max(15),
    height: z.number().min(5).max(15),
});
export const crossword_data_entry_cell_schema = z.object({
    x: z.number().min(0).max(14),
    y: z.number().min(0).max(14),
});
// entry_id e.g. 1-across
export const crossword_data_entry_id_schema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^\d+-(across|down)$/);
// clue description
export const crossword_data_clue_schema = z.string().trim().min(1).max(255);
// e.g. 1-across: clue description
export const crossword_data_clues_schema = z.record(crossword_data_entry_id_schema, crossword_data_clue_schema);
// e.g. 0,0: "A"
// 0,3: "B"
export const crossword_data_values_schema = z.record(z
    .string()
    .trim()
    .regex(/^\d+,\d+$/), z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]+$/)
    .min(1)
    .max(1));
export const crossword_data_entry_schema = z.object({
    direction: crossword_data_entry_direction_schema,
    start: crossword_data_entry_cell_schema,
    end: crossword_data_entry_cell_schema,
    human_index: z.number().min(0),
    // id: example = 1-across
    id: crossword_data_entry_id_schema,
    length: z.number().min(1).max(15),
    value: z
        .string()
        .trim()
        .toUpperCase()
        .regex(/^[A-Z]+$/)
        .min(1)
        .max(15),
});
export const crossword_data_entries_schema = z.object({
    across: z.array(crossword_data_entry_schema),
    down: z.array(crossword_data_entry_schema),
});
export const crossword_data_schema = z.object({
    dimensions: crossword_data_dimensions_schema,
    values: crossword_data_values_schema,
    entries: crossword_data_entries_schema,
    clues: crossword_data_clues_schema,
});
//# sourceMappingURL=crossword.js.map